<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<egranty-list
		header="Zespoły"
		empty-warning="Brak zespołów"
		:get-tile-title="(team) => team.name"
		:items="teams"
		icon="event_seat"
		color="orange">

		<template v-slot:avatar="slotData">
			<v-icon color="orange">event_seat</v-icon>
		</template>

		<template slot="actions" slot-scope="{ item }">
			<v-list-tile-action>
				<egranty-icon-button
					icon="assignment"
					color="primary"
					label="Zbiorcza ocena"
					for="agency-contest-teams-view-summary-evaluation"
					id="agency-contest-teams-view-summary-evaluation"
					@click="viewTeamSummaryEvaluation(item.id)"/>
			</v-list-tile-action>
		</template>
	</egranty-list>
</template>

<script>
	import {Team} from "@/api/generated/Team";
	import EgrantyList from "../../../genericComponents/EgrantyList";
	import EgrantyIconButton from "../../../genericComponents/EgrantyIconButton";

	export default {
		name: "AgencyContestEvaluationTeamsView",

		components: {EgrantyList, EgrantyIconButton},

		data () {
			return {
				agencyContestData: {
					id: this.$route.params.id,
				},
				teams: [],
			};
		},

		created () {
			loadTeams(this);
		},

		methods: {
			viewTeamSummaryEvaluation (teamId) {
				this.$router.push("/app/agency-contest/" + this.agencyContestData.id + "/evaluation-summary/teams/" + teamId);
			},
		},
	};

	function loadTeams (ctx) {
		Team.getTeams(ctx, ctx.agencyContestData.id,
			success => {
				ctx.teams = success;
			}, error => {
				ctx.$messagesBus.$emit("error", "Nie udało się pobrać listy zespołów", error);
			});
	}
</script>
